import axios from 'axios';

import createRequestOptions from '../helpers/createRequestOptions';

export const SendForm = (data, template) => axios(createRequestOptions(data, template))
  .then(res => res.data);
